const dateToQuery = (inputDate, timeToSet) => {
  const dateToReturn = timeToSet[0] === 0 ? `${inputDate}T${'00:00:00'}` : `${inputDate}T${'23:59:59'}`;

  return dateToReturn;
};

export default dateToQuery;
